import { gql } from '@apollo/client'

export const RESEND_INVITE = gql`
  mutation resendInvite($userId: Int!, $nonprofitOrgId: Int) {
    resendInvite(userId: $userId, nonprofitOrgId: $nonprofitOrgId) {
      success
    }
  }
`
